import { render, staticRenderFns } from "./Encomiendas.vue?vue&type=template&id=4629deaa&"
import script from "./Encomiendas.js?vue&type=script&lang=js&"
export * from "./Encomiendas.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports